<div id="online_video_file" *ngIf="playerConfig === 'online_video_file'">
	<video id="my_video_1" class="video-js vjs-default-skin" width="640px" height="267px" controls preload="none"
		poster='http://video-js.zencoder.com/oceans-clip.jpg'
		data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'>
		<!-- <source src="https://vjs.zencdn.net/v/oceans.mp4" type='video/mp4' /> -->
		<source src="https://vjs.zencdn.net/v/oceans.webm" type='video/webm' />
		<!-- <source src="file://F:\\Phone bkp\\bkp-whatsapp video\\VID-20180608-WA0003.mp4" type='video/webm' />  -->
	</video>
	<button (click)="playPause()">Play/Pause</button>
	<button (click)="makeBig()">Big</button>
	<button (click)="makeSmall()">Small</button>
	<button (click)="makeNormal()">Normal</button>
	<button (click)="restart();">Restart</button>
	<button (click)="skip(-10)">Rewind</button>
	<button (click)="skip(10)">Fastforward</button>
</div>

<div id="youtube_video" *ngIf="playerConfig === 'youtube_video'">
<section class="card card-info text-white bg-dark mb-3">
      <div class="card-header">{{runningVideo.name}}
      <mat-form-field class="full-width-input">
        <input matInput placeholder="height"  [ngModel]="height" required>
        <mat-error>
          Please provide valid Number
        </mat-error>
        <mat-hint>Min 100, Max 2500 number</mat-hint>
      </mat-form-field>
      
      <mat-select [(ngModel)]="width"  placeholder="Width"  (selectionChange)="youtubeVideoWidthChange($event.value)">
		    <mat-option value="200">200</mat-option>
		    <mat-option value="400">400</mat-option>
		    <mat-option value="600">600</mat-option>
		    <mat-option value="800">800</mat-option>
		    <mat-option value="1200">1200</mat-option>
		  </mat-select>
      </div>
       <!--  suggestedQuality="default/small/medium/large/hd720/hd1080/highres"  -->
      <section class="card-img-top">
        <youtube-player
          [videoId]="id"
          suggestedQuality="small"
        
          (ready)="youtubeVideoSavePlayer($event)"
          (change)="youtubeVideoOnStateChange($event)"
          (playbackQualityChange)="youtubeVideoOnQualityChange($event)"
          (playbackRateChange)="youtubeVideoOnPlayRateChange($event)"
          (error)="youtubeVideoOnError($event)"
          [height]="height"
          [width]="width"
          [playerVars]="youtubeVideoPlayerVars">
        </youtube-player>
      </section>
      <div class="card-body"></div>
    </section>
    <button [style.display]="'none'" *ngIf="ytEvent !== 1"
      type="button"
      class="btn btn-primary"
      (click)="youtubeVideoPlayVideo()">
      Play
    </button>
    <button [style.display]="'none'" *ngIf="ytEvent === 1"
      type="button"
      class="btn btn-danger"
      (click)="youtubeVideoPauseVideo()">
      Pause
    </button>
</div>
<section [style.display]="'none'" class="card card-success">
    <div class="card-body">
      <div class="card-title">Player State</div>
      <pre>{{ ytEvent }}</pre>
    </div>
</section>


<div id="player1"></div>

<section class="card card-success">
<mat-grid-list cols="4" rowHeight="3:1">
  <mat-grid-tile  *ngFor="let item of videoList">
  <button mat-button (click)='playVideo(item)'>
  	<mat-card class="my-card" >
      <mat-card-title>{{ item.name}}</mat-card-title>
      <mat-card-content>
         {{ item.description}}
      </mat-card-content>
    </mat-card> 
    </button>
    </mat-grid-tile>
</mat-grid-list>

</section>